function risk_level_parse(risk_value){
	switch (risk_value) {
		case "0":
			return "低風險";
		case "1":
			return "中風險";
		case "2":
			return "高風險";
		default:
			return "-";
	}
}

function tide_cwb(){
	var result = null, 
		data,
		tide_Icon = {
			iconUrl: 'marker_icon/tide.png',
			iconAnchor:   [15, 32],
			iconSize:     [32, 32],
			popupAnchor:  [0, -20]
		},
		geojson_data = {
			type: "FeatureCollection",
			features: []
	  	}
	data = raw_data["潮位站"] ? raw_data["潮位站"] : JSON.parse(ajax_call(publicPath + "/napi/cwb/cwb_tide_station"));
	data.forEach(function(el){
		geojson_data.features.push({
			"type": "Feature",
			"geometry": {
		      	"type": "Point",
		      	"coordinates": [el.lon, el.lat]
			},
			"properties": el
		})
	})
	var tide_layer = L.geoJSON(geojson_data,{
      	pointToLayer: function(feature, latlng) {
        	return L.marker(latlng, {
          		icon: new L.icon(tide_Icon)
        	}).bindPopup('<div id="tide_area">資料連結中...</div>');
      	}
    })
    tide_layer.on('click', onClick);
    result = [tide_layer, data];
    function onClick(e) {
		var this_marker = e.layer.feature.properties;
		setTimeout(function(){
			const empty_val_handler = (val, unit) => val == 'None' ? '-' : val + ' ' + unit;
			$('#tide_area').html(
				'<h5><b>' + this_marker.station_name + '</b></h5>' + 
				'<h6>測站編號：' + this_marker.station_id + '</h6>' +
				'<h6>觀測時間：' + this_marker.observe_time.slice(0,16).replace('T', ' ') + '</h6>' + 
				'<h6>潮高：' + empty_val_handler(this_marker.tide_height, '公尺') + '</h6>' + 
				'<h6>海水溫度：' + empty_val_handler(this_marker.sea_temperature, '攝氏度') + '</h6>' +
				'<div id="tide_div_chart" class="w-100 h-250"></div>'
			);
			var start_time = sql_query_start_time(this_marker.observe_time),
				sql_query_sta = publicPath + "/napi/cwb/cwb_tide_station?station_id=" + this_marker.station_id + "&start_time=" + start_time + "&end_time=" + this_marker.observe_time.slice(0,19);
			
			ajax_call_async(sql_query_sta, function(json){
				let data = JSON.parse(json);
				console.log(data);

				var tide_dataset = {
						"hour": [], 
						"hour_3": [], 
						"hour_6": [], 
						"hour_12": [], 
						"hour_24": []
					},
					basedTime = time_sql_processing(data[0].observe_time)
				data.forEach(function(element){
					var time = time_sql_processing(element.observe_time);
					if (isInteger((basedTime - time) / 3600000)) {
						tide_dataset["hour"].push([time, Number(element.tide_height)]);
					}
				})
				var plot_object = Highcharts.stockChart({
					chart: {
						type: 'spline',
						zoomType: 'x',
						renderTo: 'tide_div_chart'
					},
					legend: {
						enabled: true
					},
			        rangeSelector: {
			        	enabled: false
					},
					navigator: {
						enabled: false
					},
					scrollbar: {
						enabled: false
					},
			        exporting:{
			        	enabled: false
					},
					plotOptions: {
						series: {
							dataGrouping: {
								enabled: false
							}
						}
					},
			        series: [{
			        	name: "潮高",
			        	data: tide_dataset["hour"],
			        	tooltip: {valueDecimals: 2}
			        }],
			        yAxis: [{
			            title: {
			                text: "潮高(公尺)"
			            }
			        }]
				});
			})
		}, 1000);
	}
	return result;
}

function buoy_cwb(){
	var result = null, 
		data,
		tide_Icon = {
			iconUrl: 'marker_icon/buoy.png',
			iconAnchor:   [15, 32],
			iconSize:     [32, 32],
			popupAnchor:  [0, -20]
		},
		geojson_data = {
			type: "FeatureCollection",
			features: []
	  	}
	data = raw_data["浮標站"] ? raw_data["浮標站"] : JSON.parse(ajax_call(publicPath + "/napi/cwb/cwb_buoy_station"));
	data.forEach(function(el){
		geojson_data.features.push({
			"type": "Feature",
			"geometry": {
		      	"type": "Point",
		      	"coordinates": [el.lon, el.lat]
			},
			"properties": el
		})
	})
	var tide_layer = L.geoJSON(geojson_data,{
      	pointToLayer: function(feature, latlng) {
        	return L.marker(latlng, {
          		icon: new L.icon(tide_Icon)
        	}).bindPopup('<div id="buoy_area">資料連結中...</div>');
      	}
    })
    tide_layer.on('click', onClick);
    result = [tide_layer, data];
    function onClick(e) {
		var this_marker = e.layer.feature.properties;
		setTimeout(function(){
			const empty_val_handler = (val, unit) => val == 'None' ? '-' : val + ' ' + unit;
			$('#buoy_area').html(
				'<h5><b>' + this_marker.station_name + '</b></h5>' + 
				'<h6>測站編號：' + this_marker.station_id + '</h6>' +
				'<h6>觀測時間：' + this_marker.observe_time.slice(0,16).replace('T', ' ') + '</h6>' + 
				'<h6>風速：' + empty_val_handler(this_marker.wind_speed, '公尺/秒') + '</h6>' + 
				'<h6>風向(角度)：' + empty_val_handler(this_marker.wind_direction, '') + '</h6>' +
				'<h6>風向(方位)：' + empty_val_handler(this_marker.wind_direction_description, '') + '</h6>' +
				'<h6>風級：' + empty_val_handler(this_marker.wind_scale, '級') + '</h6>' +
				'<h6>浪高：' + empty_val_handler(this_marker.wave_height, '公尺') + '</h6>'
			);
		}, 1000);
	}
	return result;
}

function abnormal_waves_cwb(){
	var result = null
	var data = raw_data["異常波浪"] ? raw_data["異常波浪"] : ajax_call(publicPath + "/napi/cwb/cwb_abnormal_waves");
	var geojson_data = ajax_call("geojson/cwb/abnormal_waves_coastal_lines.json")
	geojson_data.features = geojson_data.features
		.map((el) => {
			return {
				...el,
				properties: {
					...el.properties,
					location: el.properties.location,
					time_12h: data[0]['DateTime'].split('+')[0].replace('T', ' '),
					risk_12h: data[0]['Location'].find((i) => i.LocationName == el.properties.location).RiskValue,
					time_18h: data[1]['DateTime'].split('+')[0].replace('T', ' '),
					risk_18h: data[1]['Location'].find((i) => i.LocationName == el.properties.location).RiskValue,
					time_24h: data[2]['DateTime'].split('+')[0].replace('T', ' '),
					risk_24h: data[2]['Location'].find((i) => i.LocationName == el.properties.location).RiskValue,
				}
			}
		})
	var abnormal_waves_layer = L.geoJSON(geojson_data,{
		style: {
            color: 'blue',
            weight: 5,
            opacity: 1,
        },
		onEachFeature: (feature, layer) => {
            layer.bindPopup(
                '<div id="abnormal_waves">' +
					'<h5><b>異常風浪監測：' + feature.properties.location + '</b></h5>' + 
                    '<h6>近12小時(' + feature.properties.time_12h + ')風險：' + risk_level_parse(feature.properties.risk_12h) + '</h6>' + 
                    '<h6>近18小時(' + feature.properties.time_18h + ')風險：' + risk_level_parse(feature.properties.risk_18h) + '</h6>' + 
                    '<h6>近24小時(' + feature.properties.time_24h + ')風險：' + risk_level_parse(feature.properties.risk_24h) + '</h6>' +
                '</div>'
            )
        }
	})
	result = [abnormal_waves_layer, geojson_data];
	return result;
}

function topic_weather(){
	$("#home4 .card-body").html(
		'<div class="row">' +
			'<div class="col-12 mb-1">' + 
				slider_card_component_create({
					"cardhead": "監控資料追蹤",
					"cardbody": data_source_table_html("颱風動向")
				}, false) +
				slider_card_component_create({
					"cardhead": "最新颱風資訊",
					"cardbody": '<div class="col-12" id="typhoon_info_text">讀取中...</div>'
				}) +
				slider_card_component_create({
					"cardhead": "相關氣象圖",
					"cardbody": 
						'<div class="col-12 mb-1">' +
							'<h4 class="font-weight-bold m-0">高解析度衛星雲圖-彩色</h4>' +
						'</div>'+
						'<div class="col-12 mb-2">'+
							'<img class="w-100 modal-img" src="https://cwaopendata.s3.ap-northeast-1.amazonaws.com/Observation/O-B0032-002.jpg">'+
						'</div>'+
						'<div class="col-12 mb-1">' +
							'<h4 class="font-weight-bold m-0">地面天氣圖</h4>' +
						'</div>'+
						'<div class="col-12 mb-2">'+
							'<img class="w-100 modal-img" src="https://cwaopendata.s3.ap-northeast-1.amazonaws.com/Forecast/F-C0035-001.jpg">'+
						'</div>'+
						'<div class="col-12 mb-1">' +
							'<h4 class="font-weight-bold m-0">定量降水預報</h4>' +
						'</div>'+
						'<div class="col-12 mb-2">'+
							'<img class="w-100 modal-img" src="https://www.cwa.gov.tw/Data/fcst_img/QPF_ChFcstPrecip_12_12.png">'+
						'</div>'+
						'<div class="col-12 mb-2">'+
							'<img class="w-100 modal-img" src="https://www.cwa.gov.tw/Data/fcst_img/QPF_ChFcstPrecip_12_24.png">'+
						'</div>'+
						'<div class="col-12 mb-2">'+
							'<img class="w-100 modal-img" src="https://www.cwa.gov.tw/Data/fcst_img/QPF_ChFcstPrecip_12_36.png">'+
						'</div>'+
						'<div class="col-12 mb-2">'+
							'<img class="w-100 modal-img" src="https://www.cwa.gov.tw/Data/fcst_img/QPF_ChFcstPrecip_12_48.png">'+
						'</div>'+
						'<div class="col-12 mb-1">' +
							'<h4 class="font-weight-bold m-0">滿潮預報圖-今日</h4>' +
						'</div>'+
						'<div class="col-12 mb-2">'+
							'<img class="w-100 modal-img" src="https://www.cwa.gov.tw/Data/marine/tide_predict/full_0.png">'+
						'</div>'+
						'<div class="col-12 mb-1">' +
							'<h4 class="font-weight-bold m-0">24小時波浪預報圖</h4>' +
						'</div>'+
						'<div class="col-12 mb-2">'+
							'<img class="w-100 modal-img" src="https://cwaopendata.s3.ap-northeast-1.amazonaws.com/Forecast/F-C0035-020.jpg">'+
						'</div>'
				}) +
				'<div id="tide_anchor"></div>'
				+ 
				slider_card_component_create({
					"cardhead": "潮位監測",
					"cardbody": 
						'<div class="col-12 mb-3" id="tide_table">'+
							'<table class="table table-sm text-center" width="100%">' +
								'<thead class="thead-dark">' +
									'<tr>' +
										'<th>行政區</th>' +
										'<th>站名</th>' +
										'<th>時間</th>' +
										'<th>潮位</th>' +
										'<th>海水溫度</th>' +
									'</tr>' +
								'</thead>' +
								'<tbody class="p-cursor"></tbody>' +
							'</table>'+
						'</div>'
				}) +
				'<div id="buoy_anchor"></div>'
				+
				slider_card_component_create({
					"cardhead": "浮標監測",
					"cardbody": 
						'<div class="col-12 mb-3" id="buoy_table">'+
							'<table class="table table-sm text-center" width="100%">' +
								'<thead class="thead-dark">' +
									'<tr>' +
										'<th>站名</th>' +
										'<th>時間</th>' +
										'<th>風速</th>' +
										'<th>風級</th>' +
										'<th>浪高</th>' +
									'</tr>' +
								'</thead>' +
								'<tbody class="p-cursor"></tbody>' +
							'</table>'+
						'</div>'
				}) +
				'<div id="abnormal_waves_anchor"></div>'
				+
				slider_card_component_create({
					"cardhead": "異常波浪監測",
					"cardbody": 
						'<div class="col-12 mb-3" id="abnormal_waves_table">'+
							'<table class="table table-sm text-center" width="100%">' +
								'<thead class="thead-dark">' +
									'<tr>' +
										'<th>海岸線</th>' +
										'<th>12H</th>' +
										'<th>18H</th>' +
										'<th>24H</th>' +
									'</tr>' +
								'</thead>' +
								'<tbody class="p-cursor"></tbody>' +
							'</table>'+
						'</div>'
				}) +
			'</div>' +
		'</div>'
	)
	setTimeout(function(){
		var current_info = {}, info_html_string = ""
		overlay_dataset["颱風動向"].toGeoJSON().features.forEach(function(feature){
			if (feature.properties.styleUrl == "#current" && feature.properties.description != undefined) {
				current_info[feature.properties.name] = feature.properties.description;
			};
		});
		for(var each_typhoon in current_info){
			info_html_string += '<li>' + each_typhoon + "：" + current_info[each_typhoon] + '</li>';
		}
		$("#typhoon_info_text").html((info_html_string !== "" ? info_html_string : "無資訊顯示"));
	}, 2000)

	const empty_val_handler = (val) => val == 'None' ? '-' : val;
	var raw_tide = ajax_call(publicPath + "/napi/cwb/cwb_tide_station")
	var res_tide = JSON.parse(raw_tide)
	var raw_buoy = ajax_call(publicPath + "/napi/cwb/cwb_buoy_station")
	var res_buoy = JSON.parse(raw_buoy)
	var res_abnormal_waves = ajax_call(publicPath + "/napi/cwb/cwb_abnormal_waves")

	var tide_table = [], tide_coor_object = {};
	res_tide.forEach(el => {
		tide_table.push([
			el.county + el.town, 
			el.station_name, 
			el.observe_time.slice(0,16).replace('T',' '), 
			empty_val_handler(el.tide_height), 
			empty_val_handler(el.sea_temperature)
		])
		tide_coor_object[el.station_name] = [Number(el.lat), Number(el.lon)];
	})

	var buoy_table = [], buoy_coor_object = {};
	res_buoy.forEach(el => {
		buoy_table.push([
			el.station_name, 
			el.observe_time.slice(0,16).replace('T',' '), 
			empty_val_handler(el.wind_speed),
			empty_val_handler(el.wind_scale), 
			empty_val_handler(el.wave_height)
		])
		buoy_coor_object[el.station_name] = [Number(el.lat), Number(el.lon)];
	})

	var abnormal_waves_table = [];
	abnormal_waves_table.push([
		'時間',
		res_abnormal_waves[0]['DateTime'].split('+')[0].replace('T', ' '),
		res_abnormal_waves[1]['DateTime'].split('+')[0].replace('T', ' '), 
		res_abnormal_waves[2]['DateTime'].split('+')[0].replace('T', ' ')
	])
	abnormal_waves_table.push([
		res_abnormal_waves[0]['Location'][2]['LocationName'],
		risk_level_parse(res_abnormal_waves[0]['Location'][2]['RiskValue']), 
		risk_level_parse(res_abnormal_waves[1]['Location'][2]['RiskValue']), 
		risk_level_parse(res_abnormal_waves[2]['Location'][2]['RiskValue'])
	])
	abnormal_waves_table.push([
		res_abnormal_waves[0]['Location'][0]['LocationName'],
		risk_level_parse(res_abnormal_waves[0]['Location'][0]['RiskValue']), 
		risk_level_parse(res_abnormal_waves[1]['Location'][0]['RiskValue']), 
		risk_level_parse(res_abnormal_waves[2]['Location'][0]['RiskValue'])
	])
	
	$('#tide_table table').DataTable({
        "data": tide_table,
        "deferRender": true,
        // "order": [[ 3, "desc" ]],
        "searching": true
    });

	$("#tide_table tbody").on("click", "tr", function(){
        var coor_array = tide_coor_object[$(this).find("td").eq(1).html()];
        map.setView(coor_array, 15);
    });

	$('#buoy_table table').DataTable({
		"data": buoy_table,
        "deferRender": true,
        // "order": [[ 3, "desc" ]],
        "searching": true
	});

	$("#buoy_table tbody").on("click", "tr", function(){
        var coor_array = buoy_coor_object[$(this).find("td").eq(0).html()];
        map.setView(coor_array, 15);
    });

	$('#abnormal_waves_table table').DataTable({
		"data": abnormal_waves_table,
		"deferRender": true,
		"order": [[ 0, "desc" ]],
		"searching": true
	});


}